export default __webpack_public_path__ + "static/media/bookmark4.56901523.png";